import { NODES } from '#pplx/frontend/composer-sdk/lexical/nodes/Nodes.js';
import { convertFromMarkdownStringLinksOnly } from '#pplx/frontend/composer-sdk/lexical/utils/linkMarkdown.js';
import { createEditor } from 'lexical';
/**
 * Creates a draft with Markdown links while leaving other Markdown syntax literal.
 *
 * Each line becomes a paragraph, unlike `createPlainTextComposerValue`, which
 * creates one paragraph with linebreak nodes. No block normalization is applied.
 * Loading returned link nodes into Composer requires a plugin with LinkCapability.
 */
export function createMarkdownLinksComposerValue(markdown) {
    const editor = createEditor({
        nodes: NODES,
        // Lexical otherwise logs update errors and returns an empty draft.
        onError: (error) => {
            throw error;
        },
    });
    editor.update(() => convertFromMarkdownStringLinksOnly(markdown), { discrete: true });
    return editor.getEditorState().toJSON();
}
//# sourceMappingURL=createMarkdownLinksComposerValue.js.map